import React, { useState, useEffect } from "react";
import { TextField, Button, Typography, Container } from "@mui/material";
import Layout from "../../../layout/Layout";
import VenueMenu from "../../../components/VenueMenu";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  addGeneralInformation,
  getGeneralInformation,
  editGeneralInformation,
} from "../../../services/venues/venueGeneralInformationAPI";
import ButtonBack from "../../../components/ButtonBack";

const AddEditGeneralInformation = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  let location = useLocation();
  location = location.pathname.slice(1);

  const isEditMode = location === "add-new-general-information" ? false : true;

  const [generalInfoData, setGeneralInfoData] = useState({
    icon: "",
    icon_alt_text: "",
    title: "",
  });

  useEffect(() => {
    if (id) {
      getGeneralInformation(id)
        .then((data) => {
          setGeneralInfoData({
            icon: data.icon,
            icon_alt_text: data.icon_alt_text,
            title: data.title,
          });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [id]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setGeneralInfoData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (isEditMode) {
      editGeneralInformation(id, generalInfoData)
        .then(() => {
          navigate("/general-information");
        })
        .catch((error) => {
          console.error("Greška pri ažuriranju ", error);
        });
    } else {
      addGeneralInformation(generalInfoData)
        .then(() => {
          navigate("/general-information");
        })
        .catch((error) => {
          console.error("Greška pri dodavanju", error);
        });
    }
  };

  return (
    <Layout>
      <div>
        <VenueMenu />
        <div stile={{ width: "79%" }}>
          <ButtonBack />
          <div style={{ marginLeft: "26%" }}>
            <Typography variant="h4" gutterBottom sx={{ textAlign: "center" }}>
              General Information
            </Typography>

            <form onSubmit={handleSubmit}>
              <Container>
                <div>
                  <TextField
                    sx={{ marginTop: "30px" }}
                    name="icon"
                    label="Icon"
                    value={generalInfoData.icon}
                    fullWidth
                    onChange={handleInputChange}
                  />
                </div>

                <div>
                  <TextField
                    sx={{ marginTop: "30px" }}
                    name="icon_alt_text"
                    label="Icon Alt Text"
                    value={generalInfoData.icon_alt_text}
                    fullWidth
                    onChange={handleInputChange}
                  />
                </div>

                <div>
                  <TextField
                    sx={{ marginTop: "30px" }}
                    name="title"
                    label="Title"
                    required
                    value={generalInfoData.title}
                    fullWidth
                    onChange={handleInputChange}
                  />
                </div>
              </Container>
              <Container
                sx={{
                  marginTop: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  sx={{ m: 1, width: "25ch" }}
                  type="submit"
                  size="medium"
                  variant="outlined"
                >
                  {location === "add-new-general-information"
                    ? "Publish"
                    : "Save"}
                </Button>
              </Container>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AddEditGeneralInformation;
